var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Empty } from 'antd';
import NoDataDesert from 'images/NoDataDesert.svg';
import React from 'react';
const noDataImages = {
    default: Empty.PRESENTED_IMAGE_DEFAULT,
    desert: NoDataDesert,
    simple: Empty.PRESENTED_IMAGE_SIMPLE
};
export const NoData = (_a) => {
    var { image, imageName = 'desert' } = _a, rest = __rest(_a, ["image", "imageName"]);
    return React.createElement(Empty, Object.assign({ image: image !== null && image !== void 0 ? image : noDataImages[imageName] }, rest));
};
